// extracted by mini-css-extract-plugin
export default {"user-report-container":"UserReports_user-report-container__FMMPf"};